<div id="categorys" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row"
            fxLayoutAlign.gt-sm="space-between center">

            <!-- APP TITLE -->
            <div class="logo mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16" [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
                    account_balance
                </mat-icon>
                <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                    {{'CATEGORY_LIST.categories' | translate}}
                </span>
            </div>
            <!-- / APP TITLE -->

            <!-- SEARCH -->
            <div class="search-wrapper mx-32 mx-md-0">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon> {{'search' | translate}}</mat-icon>
                    <input  (keyup)="categorySearch($event.target.value)"  placeholder="{{'CATEGORY_LIST.searchForCategory' | translate}}">
                </div>
            </div>
            <!-- / SEARCH -->

            <!-- ADD BUTTON -->
            <button mat-raised-button [routerLink]="'/category/add'"
                class="add-category-button fuse-white mt-24 mt-md-0">
                <span>{{'CATEGORY_LIST.addNewCategory' | translate}}</span>
            </button>
            <!-- / ADD BUTTON -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="list-skeleton" *ngIf="loaderService.isLoading ">
                <ngx-skeleton-loader
                    [theme]="{ width: '100%', height: '35px'}"
                    animation="progress"
                    count="10">
                </ngx-skeleton-loader>
            </div>
            <mat-table  *ngIf="!loaderService.isLoading "
            class="categorys-table custom-table" #table [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}"
                fusePerfectScrollbar>

                <!-- ID Column -->
                <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CATEGORY_LIST.id' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let category" [routerLink]="'/category/edit/' + category.id">
                        <p class="text-truncate">{{category.id}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="image">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'TENANT_LIST.logo' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let category" class="image-column">
                        <!-- ADD FILE BUTTON -->
                        <div *ngIf="category.icon ==null" class="file-uploader">
                            <input hidden type="file" #fileInput [accept]="allowedFiles"
                                (change)="uploadIcon($event , category.id)" />
                            <button mat-mini-fab class="add-file-btn" (click)="fileInput.click()" aria-label="Add file"
                                [@animate]="{value:'*', params:{delay:'300ms',scale:'0.2'}}">
                                <mat-icon>add</mat-icon>

                            </button>
                    
                        </div>
                        <div *ngIf="category.icon !=null">
                            <img src="{{'data:image/jpg;base64,' + category.icon}}" />
                        </div>
                    </mat-cell>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CATEGORY_LIST.name' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let category" [routerLink]="'/category/edit/' + category.id">
                        <p class="text-truncate">{{category.name}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CATEGORY_LIST.actions' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let category">


                        <mat-icon class="logo-icon"    (click)="edit(category.id)" 
                            [@animate]="{value:'*',params:{delay:'200ms',scale:'0.4'}}"
                            matTooltip="{{'CATEGORY_LIST.editCategory' | translate}}">
                            edit
                        </mat-icon>

                        <mat-icon class="logo-icon mx-1" (click)="deleteCategory(category.id)"
                            [@animate]="{value:'*',params:{delay:'275ms',scale:'0.6'}}"
                            matTooltip="{{'CATEGORY_LIST.deleteCategory' | translate}}">
                            delete_forever
                        </mat-icon>

                    </mat-cell>
                </ng-container>


                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let category; columns: displayedColumns;" class="category" matRipple>
                    <!-- [routerLink]="'/category/add/' + category.id" -->
                </mat-row>

            </mat-table>

            <mat-paginator 
              [length]="length"
              [pageIndex]="pageIndex - 1"
              [pageSize]="pageSize"
              (page)='categoryPagenation($event)'
              [pageSizeOptions]="pageSizeOptions">
            </mat-paginator>

        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>